import { useFormBuilderState } from "./form-builder-state";

export const changeEditModeStatus = (newStatus: boolean) => {
  useFormBuilderState.setState({ editModeStatus: newStatus });
};
